export const APPROVE_BILLS_REQUEST = "APPROVE_BILLS_REQUEST";
export const APPROVE_BILLS_SUCCESS = "APPROVE_BILLS_SUCCESS";
export const APPROVE_BILLS_FAIL = "APPROVE_BILLS_FAIL";

export const REJECT_BILLS_REQUEST = "REJECT_BILLS_REQUEST";
export const REJECT_BILLS_SUCCESS = "REJECT_BILLS_SUCCESS";
export const REJECT_BILLS_FAIL = "REJECT_BILLS_FAIL";

export const APPROVE_PAYMENTS_REQUEST = "APPROVE_PAYMENTS_REQUEST";
export const APPROVE_PAYMENTS_SUCCESS = "APPROVE_PAYMENTS_SUCCESS";
export const APPROVE_PAYMENTS_FAIL = "APPROVE_PAYMENTS_FAIL";

export const REJECT_PAYMENTS_REQUEST = "REJECT_PAYMENTS_REQUEST";
export const REJECT_PAYMENTS_SUCCESS = "REJECT_PAYMENTS_SUCCESS";
export const REJECT_PAYMENTS_FAIL = "REJECT_PAYMENTS_FAIL";